import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BRAND } from "../lib/brand";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/70 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="col-span-2">
          <div className="flex items-center gap-3">
            <img src={BRAND.logoUrl} alt="VyomSutra" className="h-10 w-auto object-contain" />
            <div>
              <div className="font-display text-xl font-extrabold text-primary">VyomSutra</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground">Essence of the Infinite</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
            India's bilingual personal transformation ecosystem. Know Yourself · Build Yourself · Become Future-Ready.
          </p>
          <div className="mt-4 space-y-1.5 text-xs text-muted-foreground">
            <div className="inline-flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> {BRAND.email}</div>
            <div className="inline-flex items-center gap-2"><Phone className="w-3.5 h-3.5" /> WhatsApp {BRAND.whatsapp}</div>
          </div>
        </motion.div>
        <div>
          <div className="label-eyebrow mb-3">BharatIQ</div>
          <ul className="space-y-2 text-sm text-foreground/80">
            <li><Link to="/bharatiq" className="hover-underline">Assessment</Link></li>
            <li><Link to="/knowledge" className="hover-underline">BharatIQ Score</Link></li>
            <li><Link to="/knowledge" className="hover-underline">Methodology & FAQ</Link></li>
            <li><Link to="/bharatiq" className="hover-underline">Career Blueprint</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">VyomSutra</div>
          <ul className="space-y-2 text-sm text-foreground/80">
            <li><Link to="/shop/wellness" className="hover-underline">Wellness</Link></li>
            <li><Link to="/shop/aura" className="hover-underline">Aura</Link></li>
            <li><Link to="/shop" className="hover-underline">All products</Link></li>
            <li><Link to="/knowledge" className="hover-underline">Knowledge Hub</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Company</div>
          <ul className="space-y-2 text-sm text-foreground/80">
            <li><Link to="/contact" className="hover-underline" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/privacy" className="hover-underline" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover-underline" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/refund" className="hover-underline" data-testid="footer-refund">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 px-6 text-xs text-muted-foreground text-center space-y-1.5">
        <div>© 2026 VyomSutra · BharatIQ. Made for India.</div>
        <div className="max-w-2xl mx-auto">BharatIQ is an educational and career-guidance platform. It does not provide clinical or medical diagnosis.</div>
      </div>
    </footer>
  );
}
